import { withStyles } from '@material-ui/core/styles';
import AssociateLogo from './AssociateLogo';
import styles from './AssociateLogo.styles';

export default withStyles(styles)(AssociateLogo);
